import React, { useEffect, useState } from "react";
import PageTitle from "../pages/PageTitle";

import todayGateEntry from "../assets/todayGateEntry.png";
import totalGateEntry from "../assets/gateEntry.png";
import todayLabEntry from "../assets/todaysLabReport.png";
import totalLabEntry from "../assets/labReport.png";
import { getAdminDashboardCountAPIURL, printLabWithGateEntryReportAPIURL } from "../commonServices/LabAndGateEntryReportAPIURL";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { pdfPathAPIURL } from "../commonServices/APIURL";
import Loader from "../pages/Loader";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const LabAndGateEntryReport = () => {
    const authUser = useSelector((state) => state.auth.user);

    const navigate = useNavigate();

    const [loader, setLoader] = useState(false);

    const [data, setData] = useState([]);

    // FETCH DATA
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        if (!authUser?.token || authUser.token.trim() === "") {
            toast.error("Authorization token missing!");
            return; // 🔥 Stop here — do not call API
        }

        setLoader(true);

        try {
            const resp = await axios.get(getAdminDashboardCountAPIURL, {
                headers: {
                    'Authorization': `Bearer ${authUser.token}`,   // 👈 Add token here
                    // OR if your API expects another header name:
                    // "x-access-token": authUser.token
                }
            });

            setData(resp.data);
            setLoader(false);
        } catch (error) {
            setLoader(false);
            toast.error("Something went wrong, please check!");
            console.error("Error fetching gate entries:", error);
        }
    };




    return (
        <>
            {
                loader == true
                    ?
                    <Loader />
                    :
                    <>
                        <PageTitle title="Report" />

                        <div className="bg-white shadow-md rounded-xl p-6 mx-auto w-full min-h-[300px]">
                            {/* ===== DASHBOARD CARDS ===== */}
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-5">

                                {/* Today Gate Entries */}
                                <div
                                    className="relative shadow-lg rounded-xl border 
                                   bg-gradient-to-br from-indigo-300 to-indigo-400 text-indigo-900 
                                   p-5 pb-16"
                                >
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <h3 className="text-sm font-semibold">Gate Entries</h3>
                                            <p className="text-4xl font-bold mt-2">{data.todayGateEntry}</p>
                                        </div>
                                        <img
                                            src={todayGateEntry}
                                            className="w-14 h-14 opacity-90"
                                            alt="Gate Today"
                                        />
                                    </div>

                                    {/* Bottom full-width button */}
                                    <button
                                        type="button"
                                        className="absolute left-0 right-0 bottom-0
                                       w-auto py-2 text-sm font-medium text-white
                                       bg-gradient-to-r from-indigo-500 to-indigo-600
                                       rounded-xl shadow-md
                                       flex items-center justify-center gap-2
                                       hover:opacity-90 transition"
                                        onClick={() => navigate('/app/gate-entry')}
                                    >
                                        Show More
                                    </button>
                                </div>

                                {/* Total Gate Entries */}
                                {/* <div
                        className="relative shadow-lg rounded-xl border 
                                   bg-gradient-to-br from-amber-300 to-amber-400 text-amber-900 
                                   p-5 pb-16"
                    >
                        <div className="flex items-center justify-between">
                            <div>
                                <h3 className="text-sm font-semibold">Total Gate Entries</h3>
                                <p className="text-4xl font-bold mt-2">{data.totalGateEntry}</p>
                            </div>
                            <img
                                src={totalGateEntry}
                                className="w-14 h-14 opacity-90"
                                alt="Total Gate"
                            />
                        </div>

                        <button
                            type="button"
                            className="absolute left-0 right-0 bottom-0
                                       w-auto py-2 text-sm font-medium text-white
                                       bg-gradient-to-r from-amber-500 to-amber-600
                                       rounded-xl shadow-md
                                       flex items-center justify-center gap-2
                                       hover:opacity-90 transition"
                            onClick={() => navigate('/app/gate-entry')}
                        >
                            Show More
                        </button>
                    </div> */}

                                {/* Today's Lab Entries */}
                                <div
                                    className="relative shadow-lg rounded-xl border 
                                   bg-gradient-to-br from-emerald-300 to-emerald-400 text-emerald-900 
                                   p-5 pb-16"
                                >
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <h3 className="text-sm font-semibold">Lab With Gate Entries</h3>
                                            <p className="text-4xl font-bold mt-2">{data.todayLabEntry}</p>
                                        </div>
                                        <img
                                            src={totalLabEntry}
                                            className="w-14 h-14 opacity-90"
                                            alt="Lab Today"
                                        />
                                    </div>

                                    <button
                                        type="button"
                                        className="absolute left-0 right-0 bottom-0
                                       w-auto py-2 text-sm font-medium text-white
                                       bg-gradient-to-r from-emerald-500 to-emerald-600
                                       rounded-xl shadow-md
                                       flex items-center justify-center gap-2
                                       hover:opacity-90 transition"
                                        onClick={() => navigate('/app/lab-report')}
                                    >
                                        Show More
                                    </button>
                                </div>

                                {/* Total Lab Entries */}
                                {/* <div
                        className="relative shadow-lg rounded-xl border 
                                   bg-gradient-to-br from-fuchsia-300 to-fuchsia-400 text-fuchsia-900 
                                   p-5 pb-16"
                    >
                        <div className="flex items-center justify-between">
                            <div>
                                <h3 className="text-sm font-semibold">Total Lab Entries</h3>
                                <p className="text-4xl font-bold mt-2">{data.totalLabEntry}</p>
                            </div>
                            <img
                                src={todayLabEntry}
                                className="w-14 h-14 opacity-90"
                                alt="Total Lab"
                            />
                        </div>

                        <button
                            type="button"
                            className="absolute left-0 right-0 bottom-0
               w-auto py-2 text-sm font-medium text-white
               bg-gradient-to-r from-fuchsia-500 to-fuchsia-600
               rounded-xl shadow-md
               flex items-center justify-center gap-2
               hover:opacity-90 transition"
                            onClick={() => navigate('/app/lab-report')}
                        >
                            Show More
                        </button>

                    </div> */}

                            </div>
                        </div>
                    </>
            }
        </>
    );

};

export default LabAndGateEntryReport;
